import * as ActionTypes from "../action-types";

export const authDossierLogin = payload => {
  return {
    type: ActionTypes.AUTH_DOSSIER_LOGIN,
    payload,
  };
};

export function authDossierLogout(tokenExpired = false, dossierNumber = "") {
  return {
    type: ActionTypes.AUTH_DOSSIER_LOGOUT,
    payload: { tokenExpired, dossierNumber },
  };
}

export function authDossierCheck() {
  return {
    type: ActionTypes.AUTH_DOSSIER_CHECK,
  };
}

export const setDossier = payload => {
  return {
    type: ActionTypes.SET_DOSSIER,
    payload,
  };
};

export const updateDossier = payload => {
  return {
    type: ActionTypes.UPDATE_DOSSIER,
    payload,
  };
};

export const setDossierLoading = payload => {
  return {
    type: ActionTypes.SET_DOSSIER_LOADING,
    payload,
  };
};

export const setInvoices = payload => {
  return {
    type: ActionTypes.SET_INVOICES,
    payload,
  };
};

export const setPaymentLoading = payload => {
  return {
    type: ActionTypes.SET_PAYMENT_LOADING,
    payload,
  };
};

export const setFaqs = payload => {
  return {
    type: ActionTypes.SET_FAQS,
    payload,
  };
};

export const setIsSubscribed = payload => {
  return {
    type: ActionTypes.SET_IS_SUBSCRIBED,
    payload,
  };
};

export const updateDebtorEmail = payload => {
  return {
    type: ActionTypes.UPDATE_DEBTOR_EMAIL,
    payload,
  };
};

export const submitPaymentArrangementRequest = payload => {
  return {
    type: ActionTypes.SUBMIT_PAYMENT_ARRANGEMENT_REQUEST,
    payload,
  };
};

export const setDossierList = payload => {
  return {
    type: ActionTypes.SET_DOSSIER_LIST,
    payload,
  };
};

export const setDateOfBirth = payload => {
  return {
    type: ActionTypes.SET_DATE_OF_BIRTH,
    payload,
  };
};
